<div class="input-wrapper">
  <div class="d-flex">
    <input
      #input
      class="lib-cm-input"
      type="text"
      [placeholder]="placeholder"
      [attr.disabled]="disabled || null"
      aria-label="Number"
      [formControl]="myControl"
      [(ngModel)]="vm"
      (ngModelChange)="setInputMask($event)"
      [matAutocomplete]="auto"
      #trigger="matAutocompleteTrigger"
      (blur)="onBlur($event)"
      (input)="onInput($event)"
      spellcheck="false"
      [ngClass]="{
        clearable: clearable,
        'border-highlighted': !!vm && highlightIfSet
      }"
      />

    @if (showAliases && aliases && aliases.length) {
      <span
        class="icon icon-alias"
        [tooltip]="ContentAlias"
        animation-duration="150"
        content-type="template"
        placement="right"
        >
        <i class="material-icons" style="color: #0071bc">content_paste</i>
      </span>
    }

    <ng-template #ContentAlias>
      <div class="tooltip-content">
        <div class="title">Aliases</div>
        @for (alias of aliases; track alias) {
          <span>{{ alias }}</span>
        }
      </div>
    </ng-template>

    @if (!!vm && clearable && !disabled) {
      <span
        class="reset-btn"
        id="atqa-reset-btn"
        (click)="reset()"
        >
        <i class="material-icons" [class.highlighted]="highlightIfSet">close</i>
      </span>
    }
  </div>
  <mat-autocomplete
    #auto="matAutocomplete"
    [autoActiveFirstOption]="true"
    (optionSelected)="optionSelected($event)"
    (closed)="onAutocompleteClosed()"
    [displayWith]="displayProperty.bind(this)"
    >
    @if (showSpinner) {
      <mat-option disabled>
        <div class="autocomplete-spinner">
          <mat-spinner [diameter]="22" class="circular-black-spinner"></mat-spinner>
        </div>
      </mat-option>
    }

    @for (option of filteredOptions | async; track option) {
      @if (!showSpinner) {
        <mat-option [value]="option">
          <div>{{ option[viewValue] }}</div>
          @if (showAliases) {
            <div class="option-sub-text">
              {{ getFormattedAliases(option?.aliases) }}
            </div>
          }
        </mat-option>
      }
    }
  </mat-autocomplete>
</div>
